import {
  DiscountCircleIcon,
  ClockIcon,
  TruckIcon,
  PlusCircleIcon,
  RocketIcon,
  StatsIcon,
  CalendarDaysIcon,
  PesoIcon,
} from '@nimbus-ds/icons';
import { TFunction } from 'i18next';
import { LimitScopeTypes } from '@tiendanube/common/src/domains/marketing/promotions/LimitScopeTypes';
import { PromotionTypes } from '@tiendanube/common/src/domains/marketing/promotions/PromotionTypes';
import { Icon } from '@tiendanube/icons/dist/icons';
import {
  CouponCustomerLimitTypes,
  CouponDateTypes,
} from 'domains/Marketing/Coupons/components/CouponForm/types';
import { buildNewCouponUrl } from 'domains/Marketing/Coupons/utils';
import { buildNewFreeShippingUrl } from 'domains/Marketing/FreeShipping/utils';
import { buildNewPromotionUrl } from 'domains/Marketing/Promotions/utils';
import { logMoreDiscountsModalOptionClick } from './tracking';
import { DiscountOption } from './types';

interface DiscountOptionConfig {
  id: string;
  icon: Icon;
  url: string;
}

const buildOptions = (
  configs: DiscountOptionConfig[],
  t: TFunction,
  goTo: (url: string) => void,
): DiscountOption[] =>
  configs.map(({ id, icon, url }) => ({
    id,
    title: t(`${id}.title`),
    description: t(`${id}.description`),
    onClick: () => {
      logMoreDiscountsModalOptionClick(id);
      goTo(url);
    },
    icon,
  }));

export const IMPROVE_CVR_OPTIONS = (
  t: TFunction,
  goTo: (url: string) => void,
) =>
  buildOptions(
    [
      {
        id: 'improveCvr.payXGetY',
        icon: DiscountCircleIcon,
        url: buildNewPromotionUrl({
          promotionType: PromotionTypes.BUY_X_PAY_Y,
          discountOptionId: 'improveCvr.payXGetY',
        }),
      },
      {
        id: 'improveCvr.timeLimitedCoupon',
        icon: ClockIcon,
        url: buildNewCouponUrl({
          dateType: CouponDateTypes.LIMITED,
          discountOptionId: 'improveCvr.timeLimitedCoupon',
        }),
      },
    ],
    t,
    goTo,
  );

export const INCREASE_AOV_OPTIONS = (
  t: TFunction,
  goTo: (url: string) => void,
) =>
  buildOptions(
    [
      {
        id: 'increaseAov.freeShipping',
        icon: TruckIcon,
        url: buildNewFreeShippingUrl('increaseAov.freeShipping'),
      },
      {
        id: 'increaseAov.crossSelling',
        icon: PlusCircleIcon,
        url: buildNewPromotionUrl({
          promotionType: PromotionTypes.CROSS_SELLING,
          discountOptionId: 'increaseAov.crossSelling',
        }),
      },
    ],
    t,
    goTo,
  );

export const OTHER_OPTIONS = (t: TFunction, goTo: (url: string) => void) =>
  buildOptions(
    [
      {
        id: 'other.seasonalPromotion',
        icon: CalendarDaysIcon,
        url: buildNewPromotionUrl({
          dateType: LimitScopeTypes.LIMITED,
          discountOptionId: 'other.seasonalPromotion',
        }),
      },
      {
        id: 'other.quantityDiscount',
        icon: PesoIcon,
        url: buildNewPromotionUrl({
          promotionType: PromotionTypes.PROGRESSIVE_DISCOUNT,
          discountOptionId: 'other.quantityDiscount',
        }),
      },
      {
        id: 'other.firstPurchaseCoupon',
        icon: RocketIcon,
        url: buildNewCouponUrl({
          customerLimitType: CouponCustomerLimitTypes.FIRST_CONSUMER_PURCHASE,
          discountOptionId: 'other.firstPurchaseCoupon',
        }),
      },
      {
        id: 'other.crossSelling',
        icon: StatsIcon,
        url: buildNewPromotionUrl({
          promotionType: PromotionTypes.CROSS_SELLING,
          discountOptionId: 'other.crossSelling',
        }),
      },
    ],
    t,
    goTo,
  );
